import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";

import Annotations from "./SidebarComponents/Annotations";
import IconSidebar from "./IconSidebar";
import { overrideSidebar } from "@safecv/shared/sharedFunction";
import { resetFeedback } from "Actions/types";
import {
  fetchVerificationAnnotationByJobId,
  fetchVerificationAnnotationStatsByJobId,
  fetchFeedbackByJobId,
} from "@safecv/actions/postActions";

import menuIcon from "@safecv/assets/Images/menu.svg";

import "./AnnotationSidebar.css";

function AnnotationSidebar(props) {
  //props received from parent component can be used
  const [isDiscardedOpen, setIsDiscardedOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(null);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [annotationSearchedValue, setAnnotationSearchedValue] = useState("");

  const {
    viewType,
    setViewType,
    isSidebarOpen,
    setIsSidebarOpen,
    setIsPdfSelected,
    isDocumentSelected,
    setIsdocumentSelected,
    spinnerLoading,
    setIsSearchEnable,
    isPlanProcessing,
    annotationPayload,
    sidebarRef,
    selectedCompliancesCheckboxValue,
    setSelectedCompliancesCheckboxValue,
    isPlanTypeCommercial,
    setSupportdocSelection,
    algoEnabled
  } = props;

  useEffect(() => {
    if (viewType) {
      setSelectedView(viewType);
      if (viewType !== "basicPdfSearch" && viewType !== "enhancedSearch") {
        props.fetchVerificationAnnotationByJobId(props.jobId, viewType);
        props.fetchVerificationAnnotationStatsByJobId(props.jobId);
        props.fetchFeedbackByJobId(props.jobId, viewType);
      }
    }

    // to reset the filter value on viewtype change
    if (filteredData) {
      setFilteredData(null);
      setAnnotationSearchedValue("");
    }
  }, [viewType]);

  const annotationData = annotationPayload.filter(
    (annotation) => !annotation.discarded
  );

  const discardedData =
    viewType === "annotated" &&
    annotationPayload.filter((annotation) => annotation.discarded);

  const annotationStatsData =
    props.annotationStats &&
    props.annotationStats.reduce(
      (obj, item) => Object.assign(obj, { [item.annotationType]: item.count }),
      {}
    );

  useEffect(() => {
    if (isSidebarOpen) {
      setSupportdocSelection(false);
    }
  }, [isSidebarOpen]);

  // will contain the annotation classification (rules/compliance) and their respective annotations.
  return (
    <>
      {isSidebarOpen && (
        <div className="landing-sidebar-container" ref={sidebarRef}>
          <div className="sidebar-header">
            <div
              className="sidebar-menu"
              onClick={() => setOpenSidebar(!openSidebar)}
            >
              <img src={menuIcon} alt="" />
            </div>
            <div className="sidebar-header-item">
              {
                {
                  annotated: `Annotations (${
                    filteredData
                      ? filteredData.length
                      : annotationStatsData?.Rules || 0
                  })`,
                  symbols: `Symbols (${
                    filteredData
                      ? filteredData.length
                      : annotationStatsData?.Symbols || 0
                  })`,
                  compliance: `Compliances (${
                    filteredData
                      ? filteredData.length
                      : annotationStatsData?.Compliance || 0
                  })
                  `,
                  violation: `Compliances (${
                    filteredData
                      ? filteredData.length
                      : annotationStatsData?.Violation || 0
                  })`,
                  "compliance,violation": `Compliances (${
                    filteredData
                      ? filteredData.length
                      : annotationStatsData?.Compliance +
                          annotationStatsData?.Violation || 0
                  })`,
                  "violation,compliance": `Compliances (${
                    filteredData
                      ? filteredData.length
                      : annotationStatsData?.Compliance +
                          annotationStatsData?.Violation || 0
                  })`,
                  basicPdfSearch: "Search",
                  enhancedSearch: "Search",
                }[selectedView]
              }
            </div>
          </div>
          {openSidebar && (
            <IconSidebar
              setViewType={setViewType}
              selectedView={selectedView}
              setOpenSidebar={setOpenSidebar}
              setSelectedView={setSelectedView}
              setIsSearchEnable={setIsSearchEnable}
              setIsDiscardedOpen={setIsDiscardedOpen}
              selectedCompliancesCheckboxValue={
                selectedCompliancesCheckboxValue
              }
              isPlanTypeCommercial={isPlanTypeCommercial}
              algoEnabled={algoEnabled}
            />
          )}
          {viewType === "annotated" && (
            <div
              className={`sidebar-footer ${
                isDiscardedOpen ? "sidebar-footer-open" : ""
              }`}
            >
              <div className="sidebar-footer-text"> Discarded </div>
              <div className="sidebar-footer-right">
                <div className="sidebar-footer-circle">
                  <div> {annotationStatsData?.Discarded || 0} </div>
                </div>
                <div onClick={() => setIsDiscardedOpen(!isDiscardedOpen)}>
                  {isDiscardedOpen ? (
                    <div className="sidebar-footer-close"> X </div>
                  ) : (
                    <div className="sidebar-footer-arrow-right" />
                  )}
                </div>
              </div>
            </div>
          )}

          <Annotations
            {...props}
            discardedData={discardedData}
            annotationData={annotationData}
            isDiscardedOpen={isDiscardedOpen}
            selectedCompliancesCheckboxValue={selectedCompliancesCheckboxValue}
            setSelectedCompliancesCheckboxValue={
              setSelectedCompliancesCheckboxValue
            }
            filteredData={filteredData}
            setFilteredData={setFilteredData}
            annotationSearchedValue={annotationSearchedValue}
            setAnnotationSearchedValue={setAnnotationSearchedValue}
          />
        </div>
      )}
      <div className="sidebar-toggle-container">
        <div
          className="sidebar-toggle"
          onClick={() => {
            if (!isSidebarOpen && isDocumentSelected) {
              setIsPdfSelected(true);
              setIsdocumentSelected(false);
            }
            setIsSidebarOpen(!isSidebarOpen);
          }}
        >
          <div className={isSidebarOpen ? "toggle-open" : "toggle-close"} />
        </div>
      </div>
      <FadeLoader
        css={overrideSidebar}
        height={15}
        width={5}
        radius={2}
        margin={2}
        color={"#4183C5"}
        loading={spinnerLoading && !isPlanProcessing && isSidebarOpen}
      />
    </>
  );
}

const mapStatetoProps = (state) => ({
  annotationPayload: state.verification.annotationPayload,
  annotationStats: state.verification.annotationStats,
  spinnerLoading: state.verification.spinnerLoading,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    fetchVerificationAnnotationByJobId: (jobId, type) => {
      dispatch(fetchVerificationAnnotationByJobId(jobId, type));
    },
    fetchVerificationAnnotationStatsByJobId: (jobId) => {
      dispatch(fetchVerificationAnnotationStatsByJobId(jobId));
    },
    fetchFeedbackByJobId: (jobId, type) => {
      dispatch(resetFeedback());
      dispatch(fetchFeedbackByJobId(jobId, type));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(AnnotationSidebar);
